import React, { Component } from 'react';
import axios from "axios";
import {
    Container, Col, Form,
    FormGroup, Label, Input,
    Button, Alert
} from 'reactstrap';
import {isAuthenticated} from "../../../_helpers/AuthCheck";

//Styles
import "./Login.css";

class Login extends Component {
    constructor(props){
        super(props);
        this.state = {
            loginError: false,
            isLoading: false,
            formData:{
                username: "",
                password: "",
            }
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        const { formData } = this.state;
        formData[event.target.name] = event.target.value;
        this.setState({
          formData
        });
    }

    handleSubmit = event => {
        event.preventDefault();
        const { formData } = this.state;
        this.setState({isLoading: true});

        axios.post('/admin/letmein', {
            username: formData.username,
            password: formData.password
        })
        .then(res => {
            var record = {token: res.data.token, timestamp: new Date().getTime() + (60 * 60 * 1000)}
            localStorage.setItem("key", JSON.stringify(record));
            this.setState({
                isLoading: false,
                formData: { username: "", password: "" }
            });
            this.redirectUser("/admin/dashboard");
        })
        .catch(error => {
            this.setState({isLoading: false});
            if (error.response) {
              this.setState({loginError: error.response.data});
            } else {
              console.error(error);
            }
        })
    }

    redirectUser = (path) => {
        this.props.history.push(path);
    }

    componentDidMount() {
        if (isAuthenticated()) {
            this.redirectUser("/admin/dashboard");
        }
    }
    
    render() {
        return (
        <div className="AdminLogin">
            <Container>
                <h2>Sign In</h2>
                { this.state.loginError 
                    && <Alert color="danger">{(this.state.loginError)}</Alert>
                }
                <Form onSubmit={ (e) => this.handleSubmit(e) }>
                    <Col>
                        <FormGroup>
                        <Label>Username</Label>
                        <Input
                            type="username"
                            name="username"
                            placeholder="Username"
                            onChange={ (e) => this.handleChange(e) }
                        />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                        <Label>Password</Label>
                        <Input
                            type="password"
                            name="password"
                            placeholder="********"
                            onChange={ (e) => this.handleChange(e) }
                        />
                        </FormGroup>
                    </Col>
                    <Button type="submit">Submit</Button>
                    {this.state.isLoading && (
                        <div className="text-center">
                            <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                        </div>
                    )}
                </Form>
            </Container>
        </div>
        );
  }
}
export default Login;
